import { inject } from '@angular/core';
import { CanActivateFn, CanActivateChildFn, Router } from '@angular/router';
import { SessionService } from '@services/session.service';

export const privateGuard: CanActivateFn = (route, state) => {
  const authorized = inject(SessionService).logged;

  if (!authorized) {
    inject(Router).navigate(['/auth']);
    return false;
  }

  return true;
};

export const privateGuardChild: CanActivateChildFn = (route, state) => {
  const authorized = inject(SessionService).logged;

  if (authorized) {
    return true;
  } else {
    inject(Router).navigate(['/auth']);
    return false;
  }
};
